import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ToastPlugin from 'vue-toast-notification';

// Begin components
import Header from './components/header.vue'
import Footer from './components/footer.vue'

import "./assets/main.css";



import 'vue-toast-notification/dist/theme-bootstrap.css';


const app = createApp(App)

app
.use(store)
.use(router)
.use(ToastPlugin)

app
.component("c-header", Header)
.component("c-footer", Footer)

app.mount('#app')
